module.exports = __webpack_public_path__ + "static/note-5-a4e78f9f06fdcbd6b659590419e00a7d.jpg";